/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEmailProfile.ts                  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/email-profile";

export class AutogenModelEmailProfile<RowType extends ModelRow> extends Endpoint<RowType, RowEmailProfileFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEmailProfile extends ModelRow<RowEmailProfileFields> {
	constructor(values?: Partial<RowEmailProfileFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEmailProfileFields {
	company_id: string;
	descr: string;
	email_address: string;
	email_bcc: string;
	email_client: string;
	email_host: string;
	email_imap_host: string;
	email_imap_password: string;
	email_imap_sent_folder: string;
	email_imap_ssl: string;
	email_imap_username: string;
	email_password: string;
	email_port: number;
	email_protocol: string;
	email_use_sent_folder: string;
	email_username: string;
	id: string;
	override_user_id: string;
}

